angular.module('tgaAdmin').controller('CourseController', [
  '$scope',
  '$state',
  '$location',
  '$filter',
  '$q',
  'hubService',
  'gameService',
  'activityService',
  'Slug',
  'flashService',
  'Papa',
  '$log',
  'modalService',
  '$translate',
  function (
    $scope,
    $state,
    $location,
    $filter,
    $q,
    hubService,
    gameService,
    activityService,
    Slug,
    flashService,
    Papa,
    $log,
    modalService,
    $translate,
  ) {
    $scope.showBack = true;

    $scope.data = {
      activities: [],
      alerts: [],
      courseId: $state.params.id || null,
      games: [],
      hubs: [],
      sortableOptions: {
        items: 'tr',
        containment: '.box-body',
        revert: 250,
        forcePlaceholderSize: true,
        forceHelperSize: true,
        tolerance: 'pointer',
        cursor: 'move',
        handle: '.handle',
        placeholder: 'ui-sortable-placeholder',
        helper(e, tr) {
          const $originals = tr.children();
          const $helper = tr.clone();
          $helper.children().each(function (index) {
            // Set helper cell sizes to match the original sizes
            $(this).width($originals.eq(index).width());
          });
          return $helper;
        },
        scroll: false,
        start(e, ui) {
          ui.placeholder.height(ui.item.height());
        },
      },
    };

    $scope.viewmodel = {
      course_id: $scope.data.course_id,
      activity_id: null,
      game_id: null,
      hub_id: null,
      items: [],
      name: null,
      description: null,
      start_date: null,
      end_date: null,
    };

    $scope.initialize = function () {
      $scope.loading = true;

      const promises = [];

      promises.push(
        activityService.getActivities().then((activities) => {
          $scope.data.activities = activities;
        }),
      );

      promises.push(
        hubService.getHubs().then((hubs) => {
          $scope.data.hubs = hubs;
        }),
      );

      promises.push(
        gameService.getGames().then((games) => {
          $scope.data.games = games;
        }),
      );

      if ($scope.data.courseId) {
        promises.push(
          hubService.getCourse($scope.data.courseId).then((course) => {
            $scope.viewmodel = { ...$scope.viewmodel, ...course };
            $scope.title = `<span class="text-muted">Edit Course /</span> ${$scope.viewmodel.name}`;
          }),
        );
      }

      $q.all(promises)
        .catch((err) => {
          // eslint-disable-next-line angular/log
          $log.log(err);
        })
        .finally(() => {
          $scope.loading = false;
        });
    };

    $scope.actions = {
      removeItem(item) {
        const index = $scope.viewmodel.items.indexOf(item);
        $scope.viewmodel.items.splice(index, 1);
      },
      deleteCourse() {
        modalService
          .showModal(
            {
              title: 'Delete Course?',
              message: 'Are you sure you want to delete this course?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;

              hubService.deleteCourse($scope.data.courseId).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> Course deleted.', 'success');
                  $state.go('v1.courseList');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.deleting = false;
                },
              );
            },
            () => {},
          );
      },
      addActivity() {
        const idToCheck = $scope.viewmodel.activity_id;

        // make sure there is no duplicate
        const inList = $scope.viewmodel.items.some((item) => item.activity_id === idToCheck);

        if (!inList) {
          const item = $scope.data.activities.find((activity) => activity.activity_id === idToCheck);

          $scope.viewmodel.items.push(item);
        }

        $scope.viewmodel.activity_id = null;
      },
      addGame() {
        const idToCheck = $scope.viewmodel.game_id;

        // make sure there is no duplicate
        const inList = $scope.viewmodel.items.some((item) => item.game_id === idToCheck);

        if (!inList) {
          const item = $scope.data.games.find((game) => game.game_id === idToCheck);

          $scope.viewmodel.items.push(item);
        }

        $scope.viewmodel.game_id = null;
      },
      submit(form) {
        $scope.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.data.courseId) {
          hubService.updateCourse($scope.viewmodel).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Course updated.', 'success');
              $state.go('v1.courseList');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        } else {
          hubService.addCourse($scope.viewmodel).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Course created.', 'success');
              $state.go('v1.courseList');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
